export const Textarea = {
  defaultProps: {
    focusBorderColor: "teal.300",
  },
}
